import React, {useEffect, useRef, useState} from 'react';
import {resetInvalidInputField} from "../../js/CommonHelper";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FloatingMenuPortal from "./FloatingMenuPortal";

const SelectNested = ({label, propertyName, required, disabled, state, itemsList = [], itemName, displayNames, showInput, showDelete, useId}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const triggerRef = useRef(null);
  const menuRef = useRef(null);
  const isNested = propertyName.includes('.') || propertyName.includes('[');

  const getNestedProperty = (baseObject, path) => path.split('.').reduce((acc, part) => {
    const match = part.match(/(\w+)\[(\d+)\]/);
    if (match) {
      const arrayName = match[1];
      const index = parseInt(match[2], 10);
      return acc && acc[arrayName] ? acc[arrayName][index] : undefined;
    }
    return acc ? acc[part] : undefined;
  }, baseObject);

  const setNestedProperty = (obj, path, value) => {
    const parts = path.split('.');
    const lastPart = parts.pop();
    const target = parts.reduce((acc, part) => {
      const match = part.match(/(\w+)\[(\d+)\]/);
      if (match) return acc[match[1]][parseInt(match[2], 10)];
      return acc[part];
    }, obj);
    const match = lastPart.match(/(\w+)\[(\d+)\]/);
    if (match) target[match[1]][parseInt(match[2], 10)] = value;
    else target[lastPart] = value;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const insideTrigger = selectRef.current && selectRef.current.contains(event.target);
      const insideMenu = menuRef.current && menuRef.current.contains(event.target);
      if (!insideTrigger && !insideMenu) setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleReset = () => {
    state.setCurrentItem((prev) => {
      const updatedItem = structuredClone(prev);
      if (isNested) setNestedProperty(updatedItem, propertyName, useId ? 0 : undefined);
      else updatedItem[propertyName] = useId ? 0 : undefined;
      return updatedItem;
    });
    state.setCurrentFormState((prev) => ({...prev, formSaveButtonDisabled: false}));
    state.setItemChanged((prev) => !prev);
  };

  const handleSelectChange = (item) => {
    const valueToSet = useId ? item.id : item;
    state.setCurrentItem((prev) => {
      const updatedItem = structuredClone(prev);
      if (isNested) setNestedProperty(updatedItem, propertyName, valueToSet);
      else updatedItem[propertyName] = valueToSet;
      return updatedItem;
    });
    state.setCurrentFormState((prev) => ({...prev, formSaveButtonDisabled: false}));
    state.setItemChanged((prev) => !prev);
    setIsOpen(false);
    setSearchTerm("");
    resetInvalidInputField(propertyName);
  };

  const currentValue = isNested
    ? getNestedProperty(state.currentItem, propertyName)
    : state.currentItem[propertyName];

  const displayValue = useId && currentValue
    ? itemsList.find((item) => item.id === currentValue) || {}
    : currentValue;

  const filteredItems = itemsList.filter((item) =>
    item && displayNames.some((displayName) =>
      item[displayName] && item[displayName].toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <div style={{display: 'flex', alignItems: 'center', minWidth: 0}} ref={selectRef}>
      <div style={{flex: 1, minWidth: 0, position: 'relative'}}>
        <div
          ref={triggerRef}
          className="form-select"
          onClick={() => !disabled && setIsOpen((open) => !open)}
          style={{cursor: disabled ? 'default' : 'pointer', backgroundColor: disabled ? '#e9ecef' : 'white'}}
          id={propertyName}
          aria-label={label}
          aria-required={required}
        >
          {displayValue && displayValue.id !== 0
            ? displayNames.map((displayName) => displayValue[displayName]).join(' ')
            : '-- Wybierz --'}
        </div>

        <FloatingMenuPortal
          open={isOpen && !disabled}
          anchorRef={triggerRef}
          menuRef={menuRef}
          minWidth={220}
          maxHeight={360}
          className="qstaff-floating-select-menu"
        >
          {(layout) => (
            <>
              {showInput && (
                <input
                  type="text"
                  className="form-control border-0 border-bottom rounded-0"
                  placeholder="Wyszukaj..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  autoFocus
                />
              )}
              <div
                className="dropdown-menu show qstaff-floating-select-list"
                style={{maxHeight: `${Math.max(80, layout.maxHeight - (showInput ? 46 : 0))}px`}}
              >
                {filteredItems.length > 0 ? filteredItems.map((item) => (
                  <button type="button" key={item.id} className="dropdown-item" onClick={() => handleSelectChange(item)}>
                    {displayNames.map((displayName) => item[displayName]).join(' ')}
                  </button>
                )) : (
                  <div className="dropdown-item text-muted">Nie znaleziono żadnych pozycji. Zaktualizuj słownik.</div>
                )}
              </div>
            </>
          )}
        </FloatingMenuPortal>
      </div>

      {showDelete && (
        <button type="button" onClick={handleReset} disabled={!(currentValue && currentValue !== 0)} className="btn btn-outline-danger">
          <FontAwesomeIcon icon={faTrashAlt}/>
        </button>
      )}
    </div>
  );
};

export default SelectNested;
